import { WORKOUT_PLANS } from "../types/actions";

const initialState = {
	workoutPlanList: {},
	searchWorkoutPlanList: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case WORKOUT_PLANS.GET_WORKOUT_PLANS:
			return { ...state, workoutPlanList: action.payload };
		case WORKOUT_PLANS.SEARCH_WORKOUT_PLANS:
			return { ...state, workoutPlanList: action.payload };
		case WORKOUT_PLANS.GET_WORKOUT_PLAN_DETAILS:
			return { ...state, workoutPlanDetails: action.payload };
		default:
			return state;
	}
};
